import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import FormulaireDeContact from "./sections/FormulaireDeContact";
import InformationsDeContact from "./sections/InformationsDeContact";
import PiedDePage from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <FormulaireDeContact />
      <InformationsDeContact />
      <PiedDePage />
    </div>;
}